module.exports = __webpack_public_path__ + "img/index-zt3.04e83528.png";